<template>
  <div>
    <!-- 客房信息 -->
    <section>
      <el-form
        :model="formInline"
        :inline="true"
        label-width="100px"
        ref="form"
      >
        <!-- <el-form-item label="单位名称" prop="company">
          <el-autocomplete
            v-model="formInline.company"
            :fetch-suggestions="querySearchAsync2"
            placeholder="请输入单位名称"
            value-key="unitName"
            clearable
            @clear="clearSearch"
            ref="myAutocomplete"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="楼 栋" prop="building">
          <el-select
            v-model="formInline.building"
            placeholder="选择楼栋"
            style="width: 120px"
            clearable=""
          >
            <el-option label="A栋" value="A栋"></el-option>
            <el-option label="B栋" value="B栋"></el-option>
            <el-option label="C栋" value="C栋"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select
            placeholder="选择状态"
            v-model="formInline.status"
            clearable
            style="width: 120px"
          >
            <el-option
              v-for="item in stateArr"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">搜索</el-button>
          <el-button @click="clearForm">清空</el-button>
          <el-popover
            placement="bottom"
            width="150"
            v-model="show"
            class="left10 right10"
          >
            <el-checkbox-group v-model="checkList" @change="checkChange">
              <el-checkbox
                :label="val"
                v-for="(val, key) in oldTitleObj"
                :key="key"
                :disabled="val == oneRow"
              ></el-checkbox>
            </el-checkbox-group>
            <el-button slot="reference">筛选列表</el-button>
          </el-popover>
        </el-form-item> -->
        <el-row style="float: right; margin-right: 20px; margin-bottom: 20px">
          <!-- <el-button
            @click="goRoom"
            style="background-color: #b5ac8b; color: white"
            >房态图</el-button
          > -->
          <el-button
            v-hasPermi="['apartment:room:add']"
            type="primary"
            @click="addClick"
            >新增客房</el-button
          >
          <el-button
            v-hasPermi="['apartment:room:adjust']"
            @click="batchAdjust"
            v-show="isOwnerShow"
            >批量调剂</el-button
          >
          
          <el-button v-hasPermi="['apartment:room:export']" @click="exportData"
            >导出</el-button
          >
        </el-row>
      </el-form>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
          v-show="isOwnerShow"
        >
        </el-table-column>
        <el-table-column
          v-for="(val, key) in titleObj"
          :prop="key"
          :label="val"
          align="center"
        ></el-table-column>
        <!-- <el-table-column prop="roomType" label="房型" align="center">
				</el-table-column> -->
        <el-table-column prop="tel" label="操作" align="center" width="300">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleView(scope.row)" type="text"
              >查看户型图</el-button
            >
            <el-button
              size="mini"
              v-hasPermi="['apartment:room:view']"
              @click="handleCheck(scope.row)"
              type="text"
              >详情</el-button
            >
            <el-button
              size="mini"
              type="text"
              v-hasPermi="['apartment:room:edit']"
              @click="handleEdit(scope.row)"
              v-show="isOwnerShow"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="text"
              v-hasPermi="['apartment:room:adjust']"
              @click="handleAdjust(scope.row)"
              v-show="isOwnerShow"
              >调剂</el-button
            >
            <el-button
              size="mini"
              type="text"
              v-hasPermi="['apartment:room:remove']"
              @click="handleDelete(scope.row)"
              v-show="isOwnerShow"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination
        background
        :page-size="pageSize"
        layout="total, prev, pager, next,sizes"
        @current-change="handleCurrentChange"
        :total="totalNum"
        @size-change="handleSizeChange"
      /> -->
    </section>

    <!-- 新增、修改模态框 -->
    <addCustomerRoom
      :title="title"
      :dialogVisible="dialogVisible"
      @changeVisible="changeVisible"
      :formDataDetail="formData"
    ></addCustomerRoom>

    <!-- 调剂 -->
    <el-dialog
      title="调剂客房"
      :visible.sync="adjustVisible"
      width="30%"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
    >
      <el-form :model="adjustForm" label-width="100px">
        <el-form-item label="调剂给">
          <el-autocomplete
            v-model="adjustForm.adjustmentCompany"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            value-key="unitName"
            clearable
            @clear="clearSearch"
            ref="myAutocomplete"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="调剂日期">
          <el-col :span="11">
            <el-date-picker
              v-model="adjustForm.adjustmentStart"
              type="date"
              placeholder="开始日期"
              value-format="timestamp"
              style="width: 80%"
            />
          </el-col>
          <el-col class="line" :span="2">—</el-col>
          <el-col :span="11">
            <el-date-picker
              v-model="adjustForm.adjustmentEnd"
              type="date"
              placeholder="结束日期"
              value-format="timestamp"
              style="width: 80%"
            />
          </el-col>
        </el-form-item>
        <el-form-item label="附件">
          <el-upload action="#" list-type="picture-card" :auto-upload="false"
            ><i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{ file }">
              <img
                class="el-upload-list__item-thumbnail"
                :src="file.url"
                alt=""
              />
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span v-if="!disabled" class="el-upload-list__item-delete">
                  <i class="el-icon-download"></i>
                </span>
                <span v-if="!disabled" class="el-upload-list__item-delete">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="adjustVisible = false">取 消</el-button>
        <el-button type="primary" @click="adjustConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import addCustomerRoom from './component/addCustomerRoom.vue'
import publicExport from '../../assets/js/publicExport.js'

export default {
  props: {
    tableData: {
      type: Array,
      required: true // 如果该属性是必需的
    }
  },
  data() {
    return {
      titleObj: {
        //表头
        company: '单位名称',
        address: '具体位置',
        building: '楼栋',
        roomNumber: '房间号',
        area: '面积(㎡)',
        orientations: '朝向',
        bed: '床位',
        status: '状态',
      },
      oldTitleObj: {}, //备份表头
      oneRow: '', //当checkList列表只有一项时,选择框不可点击
      checkList: [
        '单位名称',
        '具体位置',
        '楼栋',
        '房间号',
        '面积(㎡)',
        '朝向',
        '床位',
        '状态',
      ],
      show: false, //控制筛选列的多选框
      formInline: {
        company: '',
        building: null,
        status: null,
      },
      // tableData: [],
      ceshi: true,
      pageSize: 10, //
      currentPage: 1, //当前页号
      totalNum: 0, //总页数
      title: '',
      dialogVisible: false,
      formData: {},
      adjustVisible: false, //调剂模态框的显隐
      adjustForm: {
        adjustmentCompany: '', //调剂单位
        adjustmentCycle: null, //调剂周期
        adjustmentFilePathList: [],
        adjustmentStart: null,
        adjustmentEnd: null,
      },
      ids: [],
      isOwnerShow: true,
      stateArr: ['全部', '空闲中', '已入住', '维护中', '待入住'], //选择状态
    }
  },
  components: {
    addCustomerRoom,
  },
  mounted() {
    this.oldTitleObj = JSON.parse(JSON.stringify(this.titleObj))
    // this.getAll()
    // if (localStorage.getItem("roleId") == 2) {
    // 	this.isOwnerShow = true;
    // } else {
    // 	this.isOwnerShow = false;
    // }
  },
  methods: {
    checkChange(val) {
      //筛选列复选框被改变
      var newObj = {}
      for (var key in this.oldTitleObj) {
        if (val.indexOf(this.oldTitleObj[key]) != -1) {
          newObj[key] = this.oldTitleObj[key]
        }
      }
      this.titleObj = newObj
      if (val.length == 1) {
        //只有一列时,复选框禁止勾选
        this.oneRow = val[0]
        this.$message.warning('表格内容至少显示一列')
        return
      }
      this.oneRow = ''
    },
    goRoom() {
      this.$router.push({
        name: '房态图',
        params: {
          ceshi: true,
        },
      })
    },
    getAll() {
      if (this.formInline.status == '全部') {
        this.formInline.status = null
      }
      this.$http
        .post('/api/roomManage/queryRoom', {
          ...this.formInline,
          pageSize: this.pageSize,
          currentPage: this.currentPage,
        })
        .then((res) => {
          console.log(res)
          this.tableData = res.data.data.items
          this.totalNum = res.data.data.totalNum
        })
    },
    handleSelectionChange(val) {
      this.ids = []
      console.log(val)
      val.forEach((item) => {
        this.ids.push(item.id)
      })
    },

    //查询
    handleQuery() {
      this.getAll()
    },
    // 清空表单
    clearForm() {
      this.$refs.form.resetFields()
      this.getAll()
    },
    // 新增
    addClick() {
      this.title = '新增客房'
      this.dialogVisible = true
    },

    // 导出
    exportData() {
      publicExport(
        '/api/roomManage/exportRoom',
        {
          ...this.formInline,
          heads: this.checkList,
        },
        '客房信息列表'
      )
    },

    // 编辑
    handleEdit(row) {
      this.title = '编辑客房'
      this.dialogVisible = true
      this.formData = {
        ...row,
      }
    },
    handleView(row) {
      window.open(row.showFilePathList)
    },
    // 查看
    handleCheck(row) {
      this.$router.push({
        name: '房态图详情',
        params: {
          // isTalent: false,
          id: row.id,
          isTrue: true,
        },
      })
      sessionStorage.setItem('id', row.id)
    },

    // 单个调剂客房
    handleAdjust(row) {
      this.ids = []
      this.adjustVisible = true
      this.ids.push(row.id)
    },
    // 批量调剂
    batchAdjust() {
      this.adjustVisible = true
    },

    // 调剂客房的确定
    adjustConfirm() {
      this.$http
        .post('/api/roomManage/adjustmentRoom', {
          ...this.adjustForm,
          ids: this.ids,
        })
        .then((res) => {
          console.log('调剂客房', res)
          this.$message.success(res.data.message)
          this.adjustVisible = false
        })
    },

    handleDelete(row) {
      this.ids = []
      this.ids.push(row.id)
      this.$confirm('确定删除该信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteCheckInApply(this.ids)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },

    // 删除人才信息
    deleteCheckInApply(ids) {
      console.log(ids)
      this.$http
        .post('/api/roomManage/deleteRoom', {
          ids: ids,
        })
        .then((res) => {
          console.log(res.data.message)
          this.$message({
            type: 'success',
            message: res.data.message,
          })
          this.$emit('getAll')
          // this.getAll()
        })
    },

    // 子组件向父组件传值
    changeVisible(e) {
      console.log(e)
      this.dialogVisible = e.dialogVisible
      this.$emit('getAll')
      // this.getAll()
    },

    // 分页
    // 当前页
    handleCurrentChange(val) {
      console.log(val)
      this.currentPage = val
      this.getAll()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getAll()
    },
    // 查询所有单位信息
    querySearchAsync(queryString, cb) {
      this.$http
        .get(
          '/api/ownerManage/getOwners?company=' +
            this.adjustForm.adjustmentCompany
        )
        .then((res) => {
          console.log('查询所有单位信息', res)
          let result = res.data.data
          cb(result)
        })
    },
    //
    querySearchAsync2(queryString, cb) {
      this.$http
        .get('/api/ownerManage/getOwners?company=' + this.formInline.company)
        .then((res) => {
          console.log('查询所有单位信息', res)
          let result = res.data.data
          cb(result)
        })
    },

    // 解决el-autocomplete使用clearable，失效问题
    clearSearch() {
      this.$refs.myAutocomplete.handleFocus()
    },

    // 导入
    importData() {},
  },
}
</script>

<style scoped="scoped">
section {
  margin-top: 20px;
}
</style>
